import { IconEdit, IconTrash } from "@tabler/icons-react";
import PermissionMiddleware from "middleware/PermissionMiddleware";
import React from "react";
import { Modal, Button } from "react-bootstrap";

const CategoryModal = ({
  show,
  onHide,
  categories,
  // onAddCategory,
  handleCreate,
  handleUpdate,
  handleDelete,
}) => {
  // const [name, setName] = useState("");
  // const [type, setType] = useState("");
  // const [color, setColor] = useState("");
  // const [icon, setIcon] = useState("");

  // const handleSubmit = () => {
  //   if (!name.trim()) {
  //     alert("Category name is required");
  //     return;
  //   }

  //   const newCategory = {
  //     name,
  //     type: type || null,
  //     color: color || null,
  //     icon: icon || null,
  //   };

  //   onAddCategory(newCategory);
  //   setName("");
  //   setType("");
  //   setColor("");
  //   setIcon("");
  // };

  return (
    <Modal show={show} onHide={onHide} centered className="modal-xl">
      <Modal.Header closeButton>
        <Modal.Title>Manage Categories</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* <Form.Group className="mb-3">
          <Form.Label>New Category Name</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter category name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Type (optional)</Form.Label>
          <Form.Control
            type="text"
            placeholder="e.g. menu"
            value={type}
            onChange={(e) => setType(e.target.value)}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Color (optional)</Form.Label>
          <Form.Control
            type="text"
            placeholder="e.g. #FF5733"
            value={color}
            onChange={(e) => setColor(e.target.value)}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Icon (optional)</Form.Label>
          <Form.Control
            type="text"
            placeholder="e.g. fa-solid fa-burger"
            value={icon}
            onChange={(e) => setIcon(e.target.value)}
          />
        </Form.Group> */}

        <Button variant="primary" onClick={handleCreate}>
          Add Category
        </Button>

        <hr />
        <h6>Existing Categories</h6>
        <ul className="list-group">
          {categories.map((category, index) => (
            <li
              key={index}
              className="list-group-item d-flex justify-content-between align-items-center"
            >
              <div>
                <strong>{category.name}</strong>
                <br />
                <small>Type: {category.type || "-"}</small>
                <br />
                <small>Color: {category.color || "-"}</small>
                <br />
                <small>Icon: {category.icon || "-"}</small>
              </div>

              <div className="btn-group">
                <Button
                  variant="warning"
                  size="sm"
                  // onClick={() => console.log("Edit category", category)}
                  onClick={(e) => handleUpdate(e, category)}
                >
                  <IconEdit size={16} />
                </Button>
                <PermissionMiddleware
                  allowedPermissions={["manage_category_pos"]}
                >
                  <Button
                    variant="danger"
                    size="sm"
                    // onClick={() => onDeleteCategory(category)}
                    onClick={() => handleDelete(category.id)}
                  >
                    <IconTrash size={16} />
                  </Button>
                </PermissionMiddleware>
              </div>
            </li>
          ))}
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CategoryModal;
